import { StoryblokVideoWithOptionalText } from './StoryblokVideoWithOptionalText'

import {
  createVideoWithOptionalText,
  createYoutubeWithOptionalText,
} from './__mocks__/videoWithOptionalText'

export { createVideoWithOptionalText, createYoutubeWithOptionalText }

// Re-export for backward compatibility
export const dummyVideoWithOptionalTextStoryblok = createVideoWithOptionalText()
export const dummyYoutubeWithOptionalTextStoryblok = createYoutubeWithOptionalText()

export default StoryblokVideoWithOptionalText
